import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getBlogSettingsRequest = {};
var _getBlogSettingsResponse = {};
var _updateBlogSettingsRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _updateBlogSettingsResponse = {};
function resolveWixBlogSettingsV2BlogSettingsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'social-blog.wixapps.net': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/blog-settings-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/blog-settings-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves blog settings. */
export function getBlogSettings(payload) {
    var _a = serializer(_getBlogSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBlogSettingsResponse, {}).fromJSON;
    function __getBlogSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.settings.v2.blog_settings',
            method: 'GET',
            methodFqn: 'wix.blog.settings.v2.BlogSettingsService.GetBlogSettings',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBlogSettingsV2BlogSettingsServiceUrl({
                protoPath: '/v2/blog-settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBlogSettings.fromReq = fromReq;
    __getBlogSettings.__isAmbassador = true;
    return __getBlogSettings;
}
/** Updates blog settings. */
export function updateBlogSettings(payload) {
    var _a = serializer(_updateBlogSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBlogSettingsResponse, {}).fromJSON;
    function __updateBlogSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.settings.v2.blog_settings',
            method: 'PATCH',
            methodFqn: 'wix.blog.settings.v2.BlogSettingsService.UpdateBlogSettings',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixBlogSettingsV2BlogSettingsServiceUrl({
                protoPath: '/v2/blog-settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBlogSettings.fromReq = fromReq;
    __updateBlogSettings.__isAmbassador = true;
    return __updateBlogSettings;
}
//# sourceMappingURL=http.impl.js.map